import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ASSETS_SRC } from '@/libs/constants';
import { useStyles } from './styles';
const info = [
    {
        title: 'Работает в любой точке мира',
        description: 'Страховка работает в любой точке мира, при перелетах любой авиакомпанией',
    },
    {
        title: 'Онлайн решение о выплате',
        description: 'Не нужно ехать в страховую компанию, решение о выплате происходит моментально, онлайн',
    },
    {
        title: 'Без бумаг и волокиты',
        description: 'Не нужно собирать справки и документы, подтверждающие задержку рейса',
    },
    {
        title: 'Одна страховка на все путешествие',
        description: 'Распространяется на все перелеты вашего путешествия',
    },
];
export const Info = () => {
    const classes = useStyles();
    return (_jsx("section", { className: classes.section, children: _jsx("ul", { className: classes.infoList, children: info.map(({ title, description }, index) => (_jsxs("li", { className: classes.infoContainer, children: [_jsx("div", { className: classes.infoImageContainer, children: _jsx("img", { alt: "", src: `${ASSETS_SRC.IMAGES}/main/${index + 1}.webp`, className: classes.infoImage }) }), _jsxs("div", { className: classes.infoTitlesContainer, children: [_jsx("h3", { className: classes.infoTitle, children: title }), _jsx("p", { className: classes.infoDescription, children: description })] })] }, index))) }) }));
};
